import { createSlice } from '@reduxjs/toolkit';
import addDays from 'date-fns/addDays';
import { post } from 'api/fetch';
import formatISO from 'date-fns/formatISO';
import differenceInDays from 'date-fns/differenceInDays';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/purchaseInsurance/coverage',
  initialState: {
    isUSPurchase: false,
    hasEndDate: false,
    startDate: null,
    endDate: null,
    numberOfDays: 28,
    addons: [],
    isValid: false,

    isLoading: false,
    offer: [{ dailyInsurancePrice: 1.43 }],
    error: null,

    isReturningVoucher: false,
    voucherReturnError: null
  },
  reducers: {
    setIsUSPurchase: (state, { payload }) => {
      state.isUSPurchase = payload;
    },
    setHasEndDate: (state, { payload }) => {
      state.hasEndDate = payload;
      state.numberOfDays = 28;

      if (!payload) {
        state.endDate = null;
      } else {
        state.endDate = formatISO(addDays(new Date(state.startDate), 27));
      }
    },
    validateStep: (state, { payload }) => {
      state.isValid = payload;
    },
    setStartDate: (state, { payload }) => {
      const difference = differenceInDays(new Date(state.endDate), new Date(payload)) + 1;
      state.startDate = payload;
      // eslint-disable-next-line no-nested-ternary
      state.numberOfDays = state.hasEndDate ? (difference < 5 ? 5 : difference) : 28;
      state.endDate =
        difference < 5 || !state.hasEndDate
          ? formatISO(addDays(new Date(payload), 27))
          : state.endDate;
    },
    setEndDate: (state, { payload }) => {
      state.endDate = payload;
      state.numberOfDays =
        differenceInDays(new Date(payload), new Date(state.startDate)) + 1;
    },
    // return voucher
    returnVoucherRequest: (state) => {
      state.isReturningVoucher = true;
      state.voucherReturnError = null;
    },
    returnVoucherSuccess: (state, { payload }) => {
      state.isReturningVoucher = false;
      state.voucherReturnError = null;
      state.offer[0].availableVouchers = state.offer[0].availableVouchers.filter(
        (x) => x.id === payload
      );
    },
    returnVoucherFailure: (state, { payload }) => {
      state.isReturningVoucher = false;
      state.voucherReturnError = payload;
    },
    addonChange: (state, { payload }) => {
      const addonInState = state.addons.find((addon) => addon.id === payload.id);
      if (addonInState) {
        const index = state.addons.indexOf(addonInState);
        if (index !== -1) state.addons.splice(index, 1);
      } else {
        state.addons.push(payload);
      }
    },
    setAddons: (state, { payload }) => {
      state.addons = payload;
    }
  }
});

export const { actions } = slice;

// ================== Actions ================== //

export const setIsUSPurchase = (isUSPurchase) => (dispatch) => {
  dispatch(actions.setIsUSPurchase(isUSPurchase));
};

export const setHasEndDate = (hasEndDate) => (dispatch) => {
  dispatch(actions.setHasEndDate(hasEndDate));
};

export const setStartDate = (startDate) => (dispatch) => {
  dispatch(actions.setStartDate(formatISO(startDate)));
};

export const setEndDate = (endDate) => (dispatch) => {
  dispatch(actions.setEndDate(formatISO(endDate)));
};

export const validateStep = (isValid) => async (dispatch) => {
  dispatch(actions.validateStep(isValid));
};

export const returnVoucher = (voucherID) => async (dispatch) => {
  dispatch(actions.returnVoucherRequest());

  try {
    await post('/insurance/ni/referrals/voucher/return', { voucherID });

    dispatch(actions.returnVoucherSuccess(voucherID));
  } catch (error) {
    dispatch(actions.returnVoucherFailure(error));
  }
};

export const addonChange = (addon) => (dispatch) => {
  dispatch(actions.addonChange(addon));
};

export const setAddons = (addons) => (dispatch) => {
  dispatch(actions.setAddons(addons));
};

export default slice.reducer;
